import { ArrowDropDown } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Chip,
  InputAdornment,
  Menu,
  MenuItem,
  TextField
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import Styles from "./chip.module.scss";

export const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "20px",
    border: "1px solid #8F918D",
    height: "41px",
    padding: "0 10px",
    margin: "0 10px",
    "& fieldset": {
      borderRadius: "20px"
    }
  }
});

export const JobFamilyDropdown: FC<any> = ({
  name,
  label,
  options,
  //   onClose,
  onJobfamilyChipChange = (
    a: any,
    b: any,
    apiData: any,
    selectedData: any
  ) => {},
  selectedValues
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [itemsTodisplay, setItemsToDisplay] = useState<any>({
    showItemsCount: 3,
    expanded: false
  });

  const handleClick = (event: any, name: any) => {
    updateSelectedValues();
    setAnchorEl(event.currentTarget);
  };
  const removeDuplicates = (arr: any) => {
    return (
      arr.filter((item: any, index: any) => arr.indexOf(item) === index) || []
    );
  };
  const handleApply = () => {
    let jobfamily: any = [];
    let jobsubfamily: any = [];
    let apiData: any = { familyList: [], subFamilyList: [] };
    let selectedData: any = { familyList: [], subFamilyList: [] };
    optionsState.map((fa: any) => {
      if (fa.selected) {
        jobfamily.push(fa);
        apiData.familyList.push(fa);
        selectedData.familyList.push(fa?.key);
        fa?.jobsubfamily?.map((subFa: any) => {
          if (subFa.selected) {
            jobsubfamily.push(subFa);
            apiData.subFamilyList.push(subFa);
            selectedData.subFamilyList.push(subFa?.key);
          }
        });
      } else {
        fa?.jobsubfamily?.map((subFa: any) => {
          if (subFa.selected) {
            jobsubfamily.push(subFa);
            apiData.subFamilyList.push(subFa);
            apiData.familyList.push(fa);
            selectedData.subFamilyList.push(subFa?.key);
          }
        });
      }
    });
    apiData.familyList = removeDuplicates(apiData.familyList);
    apiData.subFamilyList = removeDuplicates(apiData.subFamilyList);

    setAnchorEl(null);
    onJobfamilyChipChange(jobfamily, jobsubfamily, apiData, selectedData);
  };

  const getFilterLabel = (filterkey: string) => {
    const filterswithLabel: any = {
      jobfamily: t("pa.jobFamily"),
      jobsubfamily: t("pa.jobSubFamily"),
      industry: t("pa.industryTitle"),
      incumbent: t("pa.incumbentsClass"),
      region: t("pa.regionTitle"),
      clientownership: t("pa.ownership"),
      numofemp: t("pa.employeeCountTitle"),
      revenuerangedesc: t("pa.revenueRangeTitle"),
      grade: t("pa.grade")
    };
    for (let key in filterswithLabel) {
      if (filterkey == key) {
        return filterswithLabel[key];
      }
    }
  };

  const getfiltersWithAll = (filters: any) => {
    let filtersWithAll = [...filters];
    filtersWithAll.unshift({ key: "ALL", label: t("pa.selectAll") });
    return filtersWithAll;
  };

  const [optionsState, setOptionsState] = useState(options);
  const [originalValues, setOriginalValues] = useState(options);
  const [selectedCount, setSelectedCount] = useState(10);
  useEffect(() => {
    updateSelectedValues();
  }, [options]);

  const updateSelectedValues = () => {
    let selectedItemCount = 0;
    const checkItemSelected = (value: number) => {
      if (value > -1) {
        selectedItemCount += 1;
        return true;
      } else {
        return false;
      }
    };
    const newData = options.map((ele: any) => {
      return {
        ...ele,
        selected: checkItemSelected(
          selectedValues?.familyList?.findIndex((data: any) => data === ele.key)
        ),
        jobsubfamily: ele?.jobsubfamily?.map((sub: any) => {
          return {
            ...sub,
            selected: checkItemSelected(
              selectedValues?.subFamilyList?.findIndex(
                (data: any) => data === sub.key
              )
            )
          };
        })
      };
    });
    setOptionsState(newData);
    setOriginalValues(newData);
    setSelectedCount(selectedItemCount);
  };

  const filter = (value: any) => {
    const data = [...originalValues];
    let filteredData: any = [];
    let val = value.trim()?.toLowerCase();
    if (val) {
      filteredData = data.filter((ele) => {
        const isParentIncludes = ele.label?.toLowerCase().includes(val);
        const hasSubArrayHas = ele?.jobsubfamily?.filter((subArray: any) =>
          subArray?.label?.toLowerCase().includes(val)
        );
        return isParentIncludes || hasSubArrayHas?.length > 0 ? true : false;
      });
      setOptionsState(filteredData);
    } else {
      setOptionsState(data);
    }
  };

  const updateParentOptions = (ele: any, index: any) => {
    const newData: any = [...optionsState];
    newData[index].selected = !optionsState[index]?.selected;
    newData[index].jobsubfamily = newData[index].jobsubfamily?.map(
      (sub: any) => {
        return {
          ...sub,
          selected: newData[index].selected ? true : false
        };
      }
    );
    setOptionsState(newData);
  };

  const updateChildOptions = (ele: any, parentIndex: any, optIndex: any) => {
    const newData: any = [...optionsState];
    const child = newData[parentIndex].jobsubfamily[optIndex];
    newData[parentIndex].jobsubfamily[optIndex].selected = !child?.selected;
    let allChecked = newData[parentIndex].jobsubfamily?.every((ele: any) => {
      return ele?.selected;
    });
    if (!allChecked) {
      allChecked = newData[parentIndex].jobsubfamily?.some((ele: any) => {
        return ele?.selected;
      });
      if (allChecked) {
        allChecked = "Indeterminate";
      }
    }
    newData[parentIndex].selected = allChecked;
    setOptionsState(newData);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setOptionsState([...originalValues]);
    updateSelectedValues();
  };

  const getCount = (label: string) => {
    return (
      <>
        {label}{" "}
        {selectedCount > 0 && (
          <span
            style={{
              backgroundColor: "#00C29B",
              padding: "10px 5px",
              marginLeft: "5px",
              borderRadius: "20px"
            }}
          >
            {selectedCount}
          </span>
        )}
      </>
    );
  };
  return options && options.length > 0 ? (
    <div>
      <Chip
        label={getCount(label)}
        onClick={(event: any) => handleClick(event, name)}
        deleteIcon={<ArrowDropDown />}
        onDelete={(event: any) => handleClick(event, name)}
        style={{ margin: 5 }}
        className={Styles.dropdownChip}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => closeMenu()}
        className={Styles.moreFiltersoptionsModel}
      >
        <div className={Styles.jobFamilyoptions}>
          {" "}
          <div className={Styles.optionsModelHeader}>
            <div className={Styles.jobFamilyoptionsModelHeading}>
              <p className={Styles.optionsModelHeadingText}>
                {t("pa.functionOrSubFunction")}
              </p>
              <CloseIcon
                style={{
                  cursor: "pointer"
                }}
                onClick={() => closeMenu()}
              />
            </div>
          </div>
          <CustomTextField
            className={Styles.jobFamilysearchTextField}
            // id="outlined-basic"
            variant="outlined"
            // value={searchTerm}
            placeholder="Search..."
            onKeyUp={(e: any) => filter(e.target.value)}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            sx={{ width: "100%" }}
          />
          <div className={Styles.filteredOptions}>
            {optionsState?.map((_filter: any, index: any) => {
              return (
                <Accordion className={Styles.moreFiltersaccordion} key={index}>
                  <AccordionSummary
                    sx={{
                      pointerEvents: "none"
                    }}
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          pointerEvents: "auto"
                        }}
                      />
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className={Styles.jobFamilyAccordionSummary}
                  >
                    <Checkbox
                      className={Styles.jobFamilyCheckbox}
                      key={_filter?.key}
                      name={_filter?.label}
                      checked={_filter?.selected}
                      style={{ marginRight: 4 }}
                      color="secondary"
                      sx={{
                        pointerEvents: "auto",
                        "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                          color: "var(--primary-color)"
                        }
                      }}
                      indeterminate={_filter?.selected === "Indeterminate"}
                      onClick={(e) => {
                        // onJobfamilyChipChange(_filter);
                        e.stopPropagation();
                        e.preventDefault();
                        updateParentOptions(_filter, index);
                      }}
                      //   checked={
                      //     values[_filter]?.filter(
                      //       (_fil: any) => _fil.key === opt.key
                      //     ).length > 0
                      //       ? true
                      //       : false
                      //   }
                    />
                    <p className={Styles.optionsModelHeadingText}>
                      {_filter?.label}
                    </p>
                  </AccordionSummary>
                  <AccordionDetails
                    className={Styles.jobFamilyAccordionDetails}
                  >
                    <div className={Styles.jobFamilyAccordionDetails}>
                      {_filter?.jobsubfamily?.map((opt: any, optIndex: any) => {
                        return (
                          <MenuItem
                            onClick={() => {
                              //   onChipMultiChange(opt, _filter);
                            }}
                            key={opt.key}
                            className={Styles.jobFamilyoptionsModelItem}
                          >
                            <span
                              className={Styles.alignEleCenter}
                              onClick={() =>
                                updateChildOptions(_filter, index, optIndex)
                              }
                            >
                              <Checkbox
                                className={Styles.jobFamilyCheckbox}
                                key={opt?.key}
                                name={opt?.key}
                                style={{ marginRight: 4 }}
                                color="secondary"
                                checked={opt?.selected}
                                //   checked={
                                //     values[_filter]?.filter(
                                //       (_fil: any) => _fil.key === opt.key
                                //     ).length > 0
                                //       ? true
                                //       : false
                                //   }
                              />
                              {opt?.label}
                            </span>
                          </MenuItem>
                        );
                      })}
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </div>
          <div className={Styles.buttonsBlock}>
            <Button
              onClick={(event) => {
                handleApply();
              }}
              variant="contained"
              color="primary"
              className={Styles.applyButton}
              sx={{
                backgroundColor: "var( --primary-color)",
                color: "var(--contained-button-text)",
                textTransform: "none",
                fontWeight: 700,
                "&:hover": {
                  backgroundColor: "var(--primary-color)"
                }
              }}
              // disabled={isApplyButtonDisabled()}
            >
              Apply
            </Button>
            <Button
              onClick={(event: any) => {
                setAnchorEl(null);
                onJobfamilyChipChange([], []);
                //   onChipMultiChange("CLEAR_ALL", filters);
              }}
              color="primary"
              className={Styles.clearButton}
              sx={{ textTransform: "none", fontWeight: 700 }}
              // disabled={isApplyButtonDisabled()}
            >
              Clear All
            </Button>
          </div>
        </div>
      </Menu>
    </div>
  ) : (
    <></>
  );
};
